export default {
  title: 'Recevoir des actualités et offres par e-mail',
  form: {
    marketing_subscription: {
      label: 'Recevez des offres exclusives, des réductions et des actualités directement dans votre boîte mail',
    },
  },
};
